import { Inject, Injectable } from "@angular/core";
import { createEffect } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { AuthSelector, CORE_ROUTE, CoreState } from "@obg/ngx.core";
import { RouteAction, RouteSelector } from "@obg/ngx.router";
import { DataBusFacade, EventBusFacade } from "remote-module-context";
import { map, tap, withLatestFrom } from "rxjs/operators";

import { T_SHELL_DATA_BUS_FACADE, T_SHELL_EVENT_BUS_FACADE } from "../injection";
import { observeEvent } from "../util/observe-event";

@Injectable({
	providedIn: "root",
})
export class AuthEffects {
	authStatus$ = createEffect(
		() =>
			this.store
				.select(AuthSelector.getAuthenticationStatus)
				.pipe(tap((status) => this.dataBus.dispatch({ key: "authStatus", value: status }))),
		{ dispatch: false }
	);

	sessionToken$ = createEffect(
		() =>
			this.store
				.select(AuthSelector.getSessionToken)
				.pipe(tap((token) => this.dataBus.dispatch({ key: "sessionToken", value: token }))),
		{ dispatch: false }
	);

	isAuthenticated$ = createEffect(
		() =>
			this.store
				.select(AuthSelector.isAuthenticated)
				.pipe(
					tap((isAuthenticated) => this.dataBus.dispatch({ key: "isAuthenticated", value: isAuthenticated }))
				),
		{ dispatch: false }
	);

	requestAuthentication$ = createEffect(() =>
		observeEvent<undefined>(this.eventBus, "requestAuthentication").pipe(
			withLatestFrom(this.store.select(RouteSelector.getCurrent)),
			map(([, currentRoute]) =>
				RouteAction.navigate(CORE_ROUTE.auth.login, undefined, {
					queryParams: { returnUrl: currentRoute?.externalUrl },
				})
			)
		)
	);

	constructor(
		@Inject(T_SHELL_EVENT_BUS_FACADE) public eventBus: EventBusFacade,
		@Inject(T_SHELL_DATA_BUS_FACADE) public dataBus: DataBusFacade,
		private store: Store<CoreState>
	) {}
}
